import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import { Offcanvas, Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import apiHandler from "../../common/api";
import "./MyCalendar.css";

import { dateFormat } from "../../common/common";
import AddStaffBlockBreakTime from "../BusinessHours/AddStaffBloackBreakTIme";

import AddStaffappointment from "../BusinessHours/AddStaffappointment";
import { setBookingValue } from "../../../core/redux/action";
import { useParams } from "react-router-dom";

const localizer = momentLocalizer(moment);
const DnDCalendar = withDragAndDrop(Calendar);

const MyCalendar = () => {
  const userData = useSelector((state) => state.user_data);
  const BookingValue = useSelector((state) => state.BookingValue);
  const param = useParams();
  const paramID = param?.id;
  // const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showAppoimentDetailModal, setShowAppoimentDetailModal] =
    useState(false);
  const businessId = userData?.businessId;
  const dispatch = useDispatch();
  const [minHoursDropdown, setMinHoursDropdown] = useState([]);
  const [events, setEvents] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [offcanvasShow, setOffcanvasShow] = useState(false);
  const [selectedAction, setSelectedAction] = useState({ title: "Off Cover" });
  const [businessDetails, setBusinessDetails] = useState({});
  //console.log(businessDetails, "75344");
  const [businessHours, setbusinesshours] = useState([]);
  const [viewtype, setviewtype] = useState("week");
  const [paramsID, setParamsID] = useState(paramID);
  const [filterAppointmentID, setFilterAppointmentID] = useState(0);
  const [appintmentServiceData, setAppintmentServiceData] = useState([]);
  const [productlist, setProductlist] = useState([]);
  const [teamList, setTeamList] = useState([]);
  console.log(productlist);
  console.log(BookingValue);
  console.log(selectedAction);

  const [calendarDate, setCalendarDate] = useState({
    startDate: moment().startOf("week").format("YYYY-MM-DD"),
    endDate: moment().endOf("week").format("YYYY-MM-DD"),
  }); // day

  const [slotTypeList] = useState([
    { id: 1, title: "Appointment" },
    { id: 2, title: "Group" },
    { id: 3, title: "Blocked" },
  ]);

  const prodcutDataListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Business/businessappointmentbyid?businessId=${userData?.businessId || 0
        }`,
    });
    if (response.ResponseCode === "SUCCESS") {
      setProductlist(response.ResponseData?.Appointments);
      setAppintmentServiceData(response.ResponseData?.AppointmentsServices);
    }
  };

  const getAllTeamData = async (bId) => {
    try {
      const { ResponseCode, ResponseData } = await apiHandler({
        method: "GET",
        route: `Superadmin/TeamListbybusinessId?businessId=${bId}`,
      });

      if (ResponseCode !== "SUCCESS")
        throw new Error("Failed to fetch team list");

      const finalData = ResponseData?.map((team) => ({
        ...team,
        name: team?.fullName,
        resourceTitle: team?.fullName,
        resourceId: team?.id,
      }));
      setTeamList(finalData);
    } catch (error) {
      console.error("Error fetching team data:", error);
    }
  };

  const getTimeIntervals = async () => {
    try {
      // add get full hours for dropdown
      const multipleTablesData = await apiHandler({
        method: "GET",
        route: "Business/getMultipleTablesData",
        payload: { tableNames: "timeIntervals" }, // make sure dont add space in the string and its correct.
      });
      if (multipleTablesData.ResponseCode === "SUCCESS") {
        const formatData = multipleTablesData.ResponseData[0].map((hours) => ({
          ...hours,
          label: hours.timeLabel,
          value: hours.timeValue,
        }));

        setMinHoursDropdown(formatData);
      }
    } catch (error) {
      console.error("Error fetching time intervals:", error);
    }
  };

  const getServiceData = async () => {
    try {
      // add get full hours for dropdown
      const multipleTablesData = await apiHandler({
        method: "GET",
        route: "Business/getMultipleTablesData",
        payload: { tableNames: "timeIntervals" }, // make sure dont add space in the string and its correct.
      });
      if (multipleTablesData.ResponseCode === "SUCCESS") {
        const formatData = multipleTablesData.ResponseData[0].map((hours) => ({
          ...hours,
          label: hours.timeLabel,
          value: hours.timeValue,
        }));

        setMinHoursDropdown(formatData);
      }
    } catch (error) {
      console.error("Error fetching time intervals:", error);
    }
  };

  useEffect(() => {
    getTimeIntervals();
    getServiceData();
  }, []);

  useEffect(() => {
    prodcutDataListApi();
  }, [events]);

  useEffect(() => {
    if (userData) {
      getAllTeamData(businessId); // userData?.businessId
    }
  }, [userData]);

  const getAllEventsData = async (bId) => {
    try {
      const responseData = await apiHandler({
        method: "GET",
        route: `Business/getBusinessStaffAppointmentById?businessId=${bId}&startDate=${calendarDate?.startDate}&endDate=${calendarDate?.endDate}`,
      });

      if (responseData?.ResponseCode !== "SUCCESS") {
        console.error("Failed to fetch team list:", responseData);
        return;
      }

      const { businessHoliday, businessHalfHoliday, businessHours, events } =
        responseData.ResponseData;

      setbusinesshours(businessHours);

      // Get working days
      const workingDays = businessHours
        ?.filter((el) => el.isDayOff !== 1)
        ?.map((day) => day.dayId);

      // Get today's business hours
      const todayBusinessHours = businessHours?.find(
        (day) =>
          day?.daydate == moment(calendarDate?.startDate).format("YYYY-MM-DD")
      );

      const startTime = new Date(
        `${todayBusinessHours?.daydate} ${todayBusinessHours?.startTime}`
      );
      const endTime = new Date(
        `${todayBusinessHours?.daydate} ${todayBusinessHours?.endTime}`
      );


      console.log(moment(calendarDate?.startDate).format("YYYY-MM-DD"), businessHours, startTime, endTime, "75344", todayBusinessHours?.startTime, todayBusinessHours?.endTime);

      // Full-day holidays

      const holidays = businessHoliday?.map((date) => new Date(date));

      const halfDayLeaveEvents = businessHalfHoliday?.map((d, index) => {
        return {
          id: `halfday-${d.id}-${index}`, // unique ID per staff & date
          title: `Half Day Leave (${d.startTime} – ${d.endTime})`,
          breakeTitle: "Half Day Leave",
          start: new Date(`${d.date}T${d.startTime}`),
          end: new Date(`${d.date}T${d.endTime}`),
          type: "halfday",
          breaktype: 0,
          isApproved: 1,
          isDayOff: 0,
          resourceId: d.id,
          backgroundColor: "#FFF3CD",
          border: "1px solid #FFEEBA",
          color: "#856404",
          fontWeight: "bold",
          borderLeft: "5px solid #856404",
          opacity: 0.9,
        };
      });

      // Regular business/staff events
      const mainEvents = events?.map((event) => {
        const isFullDayOff = event?.type === 3 && event?.dayOff === 1;
        const title =
          event?.breakeTitle == null
            ? "Any professional"
            : `${event?.breakName || "Custom"}: ${event?.breakeTitle}`;

        return {
          id: event?.id,
          title, // ✅ This uses the 'title' property, not 'breakeTitle'
          start: isFullDayOff
            ? new Date(`${event?.daydate}T00:00:00`)
            : new Date(`${event?.daydate}T${event?.startTime}`),
          end: isFullDayOff
            ? new Date(`${event?.daydate}T23:59:59`)
            : new Date(`${event?.daydate}T${event?.endTime}`),
          // resourceId: event?.staffId,
          resourceId: event?.staffId ? event?.staffId : "any",
          type: event?.type,
          isDayOff: event?.dayOff || 0,
          date: event?.daydate,
          description: event?.description || "",
          isApproved: event?.isApproved || 0,
          breakeTitle: event?.breakeTitle || "",
          breaktype: event?.breaktype || 0,
          colorCode: event?.colorCode || "var(--primary)",
          lightCode: event?.lightCode || "var(--primary-light)",
          darkCode: event?.darkCode || "var(--primary-dark)",
          breakName: event?.breakName,
        };
      });

      const allEvents = [...(mainEvents || []), ...(halfDayLeaveEvents || [])];

      setEvents(allEvents);

      setBusinessDetails({
        startTime,
        endTime,
        workingDays,
        holidays,
      });
    } catch (error) {
      console.error("Error fetching service data:", error);
    }
  };

  useEffect(() => {
    getAllEventsData(businessId);
  }, [calendarDate]);

  const { defaultDate, views } = useMemo(
    () => ({
      defaultDate: new Date(),
      views: [
        Views.DAY,
        Views.WEEK,
        Views.MONTH,
        // Views.WORK_WEEK,
        Views.AGENDA,
      ],
    }),
    []
  );

  const handleSelectEvent = useCallback(
    (event) => {
      // If coming from appointmentlist page (param.id exists), just open offcanvas
      if (paramsID > 0) {
        setSelectedSlot({
          ...event,
          slotName: teamList?.find((el) => el.id == event?.resourceId)?.name,
        });
        setOffcanvasShow(true);
        setParamsID(null);
      } else {
        // Otherwise, navigate from calendar to appointmentlist page
        if (event?.id > 0) {
          // navigate(`/appointmentlist/${event?.id}`);
          setShowAppoimentDetailModal(true);
          setFilterAppointmentID(event?.id);
        } else {
          setSelectedSlot({
            ...event,
            slotName: teamList?.find((el) => el.id == event?.resourceId)?.name,
          });
          setOffcanvasShow(true);
        }
      }
    },
    [paramsID, teamList]
  );

  useEffect(() => {
    if (paramsID > 0 && events?.length > 0) {
      const matchedEvent = events.find((ev) => ev.id == param.id);
      if (matchedEvent) {
        handleSelectEvent(matchedEvent);
        setParamsID(null);
      }
    }
  }, [paramsID, events, handleSelectEvent]);

  const moveEvent = useCallback(
    ({ event, start, end, resourceId }) => {
      setEvents((prev) =>
        prev.map((ev) =>
          ev.id === event.id ? { ...ev, start, end, resourceId } : ev
        )
      );
    },
    [setEvents]
  );

  const resizeEvent = useCallback(
    ({ event, start, end }) => {
      setEvents((prev) =>
        prev.map((ev) => (ev.id === event.id ? { ...ev, start, end } : ev))
      );
    },
    [setEvents]
  );

  const handleSelectSlot = (selectData) => {
    setSelectedSlot(selectData);
    setShowModal(true);
  };

  const handleActionSelect = (action) => {
    setSelectedAction({ title: action });
    setShowModal(false);
    setOffcanvasShow(true);
    setSelectedSlot({
      ...selectedSlot,
      id: 0,
      slotName: teamList?.find((el) => el.id == selectedSlot?.resourceId)?.name,
      date: moment(selectedSlot?.start).format("YYYY-MM-DD"),
      type: slotTypeList.find((el) => el.title == action)?.id,
    });
  };

  const isHoliday = (date) => {
    return businessDetails.holidays?.some(
      (holiday) => holiday.toDateString() === date.toDateString()
    );
  };

  const dayPropGetter = (date) => {
    if (isHoliday(date)) {
      return {
        style: {
          backgroundColor: "var(--cal-light-red)", // yellow
          color: "var(--cal-dark-red)",
        },
      };
    } else {
      return {
        style: {
          backgroundColor: "#fefefe", // WhiteSmoke
          color: "#252525",
        },
      };
    }
  };

  const eventPropGetter = useCallback((event, start, end, isSelected) => {

    let style = {};

    if (event.isCompleted) {
      style = {
        ...style,
        backgroundColor: "black",
      };
    }

    if (event.isAvailable) {
      style = {
        ...style,
        backgroundColor: "var(--cal-light-green)",
        opacity: 1,
        width: "100%",
      };
    }

    if (isSelected) {
      style = {
        ...style,
        backgroundColor: event?.lightCode,
        color: event?.darkCode,
        border: "none",
      };
    }

    // Then handle other event types
    if (event?.breakName === "Appointment") {
      style = {
        ...style,
        backgroundColor: event?.lightCode,
        color: event?.darkCode,
        borderLeft: `5px solid ${event?.darkCode}`,
        borderRight: "none",
        borderTop: "none",
        borderBottom: "none",
      };
    }

    if (event?.type === 3) {
      style = {
        ...style,
        backgroundColor: "var(--cal-light-yellow)",
        color: "var(--cal-dark-yellow)",
        borderLeft: `5px solid var(--cal-dark-yellow)`,
        borderRight: "none",
        borderTop: "none",
        borderBottom: "none",
      };
    }
    if (event?.type === "halfday") {
      return {
        style: {
          backgroundColor: "#ffe1e1",
          color: "black",
          border: "none",
          width: "100%"
        },
      };
    }

    if (event.resourceId === "any") {
      return {
        style: {
          backgroundColor: "#e5e5e5",
          color: "black",
          borderLeft: "5px solid #333",
          borderRight: "none",
          borderTop: "none",
          borderBottom: "none",
          fontWeight: "600",
        }
      };
    }


    return { style };
  }, []);

  const CustomResourceHeader = ({ label, resource }) => (
    (
      <div
        style={{
          backgroundColor: resource?.lightCode,
          color: resource?.darkCode,
          padding: "5px",
          textAlign: "center",
        }}
      >
        {label}
      </div>
    )
  );

  // Handle view change (month, week, day, agenda)
  const handleViewChange = (newView) => {
    setviewtype(newView);
    setCalendarDate({
      startDate: moment().startOf(newView).format("YYYY-MM-DD"),
      endDate: moment().endOf(newView).format("YYYY-MM-DD"),
    });
  };

  // Handle navigation (next, prev, today buttons)
  const handleNavigate = (newDate, view) => {
    setCalendarDate({
      startDate: moment(newDate).startOf(view).format("YYYY-MM-DD"),
      endDate: moment(newDate).endOf(view).format("YYYY-MM-DD"),
    });
  };

  const handleCloseOffCover = () => {
    setOffcanvasShow(false);
    setSelectedSlot(null);
    getAllEventsData(businessId);

    let BookingValues = {
      SelectedCustomer: -1,
      ID: 0,
      formvalue: {
        FirstName: "",
        LastName: "",
        MobileNumber: 0,
        Email: "",
        Date: "",
        ID: 0,
      },
      GroupCustomers: [
        {
          label: "Walk in Customer",
          value: -1,
          email: "",
          checked: true,
          PlaceValue: 1,
        },
      ],

      ServiceData: [],
      IndiviualCustomer: true,
      GroupCustomer: false,
    };
    dispatch(setBookingValue(BookingValues));
  };

  const formatDBPhoneNumber = (number) => {
    if (!number) return "";

    let cleaned = number.replace(/\D/g, ""); // remove non-digits
    if (cleaned.startsWith("61")) {
      cleaned = "+" + cleaned;
    } else if (cleaned.startsWith("0")) {
      cleaned = "+61" + cleaned.substring(1);
    } else if (!cleaned.startsWith("+61")) {
      cleaned = "+61" + cleaned;
    }

    const noPlus = cleaned.replace("+", "");

    return "+" + noPlus.replace(/^61(\d)(\d{4})(\d{4})$/, "61 $1 $2 $3");
  };

  useEffect(() => {
    setEvents((prev) => [
      ...prev,
      {
        id: "halfday-test",
        title: "Half Day Leave",
        start: new Date("2025-10-17T09:00:00"),
        end: new Date("2025-10-17T12:00:00"),
        type: "halfday",
        resourceId: teamList[0]?.id || null,
      },
    ]);
  }, []);


  const anyProfessionalResource = {
    id: "any",
    resourceId: "any",
    resourceTitle: "Any Professional",
    name: "Any Professional",
    lightCode: "#e5e5e5",
    darkCode: "#333"
  };


  return (
    <>
      <Modal
        show={showAppoimentDetailModal}
        onHide={() => setShowAppoimentDetailModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton style={{ borderBottom: "1px solid #ddd" }}>
          <Modal.Title style={{ fontWeight: 600, color: "#000000ff" }}>
            Service Details - Appointment
            {/* {filterAppointmentID} */}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          style={{ backgroundColor: "#fafafa", borderRadius: "12px" }}
        >
          {appintmentServiceData?.filter(
            (el) => el.appointmentId === filterAppointmentID
          )?.length > 0 ? (
            (() => {
              const services = appintmentServiceData.filter(
                (el) => el.appointmentId === filterAppointmentID
              );

              const common = services[0];

              return (
                <div
                  style={{
                    padding: "10px",
                    background: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  {/* Common details */}
                  <div style={{ marginBottom: "12px", fontSize: "0.9rem" }}>
                    <div style={{ fontWeight: "600", color: "#5a2c83" }}>
                      <span className="text-black">Person: </span>{" "}
                      {common.customerName || "Customer"}
                    </div>
                    <div style={{ fontWeight: "600", color: "#5a2c83" }}>
                      <span className="text-black">Number: </span>{" "}
                      {formatDBPhoneNumber(common.customerNumber)}
                    </div>
                    <div style={{ fontWeight: "600", color: "#6b1e99" }}>
                      <span className="text-black">Time: </span>
                      {`${new Date(common.Date).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })} - ${new Date(`1970-01-01T${common.startTime}`)
                        .toLocaleTimeString("en-US", {
                          hour: "numeric",
                          minute: "2-digit",
                          hour12: true,
                        })
                        .replace(" AM", "")
                        .replace(" PM", "")}`}
                    </div>
                    <div
                      style={{
                        color:
                          common.paymentStatus?.toLowerCase() === "paid"
                            ? "#00b86b"
                            : "#c07600",
                      }}
                    >
                      <span className="text-black">Payment Status: </span>
                      <strong>
                        {common.paymentStatus?.toLowerCase() === "paid"
                          ? `Paid ($${common?.Total})`
                          : `Pay At Venue ($${common?.Total})`}
                      </strong>
                    </div>
                  </div>

                  {/* Table for services */}
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "0.85rem",
                    }}
                  >
                    <thead>
                      <tr className="text-black fw-bold">
                        <th
                          style={{ border: "1px solid #ddd", padding: "6px" }}
                          align="left"
                        >
                          Service
                        </th>
                        <th
                          style={{ border: "1px solid #ddd", padding: "6px" }}
                          align="left"
                        >
                          Duration
                        </th>
                        <th
                          style={{ border: "1px solid #ddd", padding: "6px" }}
                          align="left"
                        >
                          Member
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {services.map((s) => (
                        <tr key={s.appointmentdetileId}>
                          <td
                            className="text-black"
                            style={{ border: "1px solid #ddd", padding: "6px" }}
                          >
                            {s.serviceName}
                          </td>
                          <td
                            className="text-black"
                            style={{ border: "1px solid #ddd", padding: "6px" }}
                          >
                            {s.serviceduration}
                          </td>
                          <td
                            className="text-black"
                            style={{ border: "1px solid #ddd", padding: "6px" }}
                          >
                            {s.teamName || "Any Professional"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              );
            })()
          ) : (
            <div className="text-center text-muted">
              No services found for this appointment.
            </div>
          )}
        </Modal.Body>
      </Modal>
      <div style={{ height: "100vh", position: "relative" }}>
        <DnDCalendar
          selectable
          resizable
          defaultDate={defaultDate}
          defaultView={Views.WEEK} // Views.DAY
          events={events}
          localizer={localizer}
          resources={[...teamList, anyProfessionalResource]}
          resourceIdAccessor="resourceId"
          resourceTitleAccessor="resourceTitle"
          onSelectSlot={handleSelectSlot}
          onSelectEvent={handleSelectEvent}
          onEventDrop={moveEvent}
          onEventResize={resizeEvent}
          onView={handleViewChange}
          onNavigate={handleNavigate}
          step={30}
          timeslots={2}
          min={businessDetails?.startTime}
          max={businessDetails?.endTime}
          //         min={new Date(1970,0,1,9,0)}
          // max={new Date(1970,0,1,18,0)}
          views={views}
          draggableAccessor={() => true}
          resizableAccessor={() => true}
          scrollToTime={new Date()}
          popup
          dayPropGetter={dayPropGetter}
          eventPropGetter={eventPropGetter}
          longPressThreshold={250}
          components={{
            // event: CustomEvent,
            resourceHeader: CustomResourceHeader,
          }}
        />

        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              {selectedSlot
                ? dateFormat(selectedSlot.start, true) // true for add time
                : "Select a time"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ul className="list-unstyled">
              {slotTypeList.map((slot) => (
                <li
                  key={slot.id}
                  onClick={() => handleActionSelect(slot.title)}
                >
                  <Button variant="primary" className="w-100 mb-2">
                    {slot.title}
                  </Button>
                </li>
              ))}
            </ul>
          </Modal.Body>
        </Modal>

        <Offcanvas
          show={offcanvasShow}
          onHide={() => setOffcanvasShow(false)}
          placement="end"
          backdrop="static"
          className="offcanvas-fullscreen"
        >
          {selectedSlot?.type == 3 ? (
            <>
              <Offcanvas.Header closeButton>
                <Offcanvas.Title className="text-lg font-semibold">
                  {selectedSlot?.slotName} Add Time Off{" "}
                </Offcanvas.Title>
              </Offcanvas.Header>
              <AddStaffBlockBreakTime
                minHoursDropdown={minHoursDropdown}
                resourceData={selectedSlot}
                businessId={businessId}
                callbackHandelCancle={handleCloseOffCover}
                teamList={teamList}
              />
            </>
          ) : (
            <>
              <>
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title>Appointment</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body
                  className=""
                  style={{ width: "fit-content", display: "flex" }}
                >
                  <AddStaffappointment
                    resourceData={selectedSlot}
                    viewtype={viewtype}
                    businessHours={businessHours}
                    callbackHandelCancle={handleCloseOffCover}
                  />
                </Offcanvas.Body>
              </>
            </>
          )}
        </Offcanvas>
      </div>
    </>
  );
};

export default MyCalendar;
